import { render, staticRenderFns } from "./recent-settlements.vue?vue&type=template&id=525bfaea&scoped=true&"
import script from "./recent-settlements.vue?vue&type=script&lang=js&"
export * from "./recent-settlements.vue?vue&type=script&lang=js&"
import style0 from "./recent-settlements.vue?vue&type=style&index=0&id=525bfaea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525bfaea",
  null
  
)

export default component.exports